export const NAV_LIST = [
    {
        label: "Onboarding",
        href: "/onboarding",
    },
];

export function generate_tabs_onboarding(data = null, onlyVisible = true) {
    const tabs = {
        waiting_preonboarding: {
            id: 0,
            label: "A démarrer",
            description: data?.waiting_preonboarding_users?.length ?? 0,
            backend_string: "waiting_preonboarding",
            visible: true,
        },
        preonboarding: {
            id: 1,
            label: "Pré-onboarding",
            description: null,
            backend_string: "preonboarding",
            visible: true,
        },
        fiche_de_renseignement: {
            id: 5,
            label: "Fiche employé",
            description: null,
            backend_string: "fiche_de_renseignement",
            visible: false,
        },
        onboarding: {
            id: 2,
            label: "En cours",
            description: null,
            backend_string: "onboarding",
            visible: true,
        },
        end_onboarding: {
            id: 3,
            label: "À clôturer",
            description: data?.end_onboarding_users?.length ?? 0,
            backend_string: "end_onboarding",
            visible: true,
        },
        suivi: {
            id: 4,
            label: "Historique",
            description: null,
            backend_string: "suivi",
            visible: true,
        },
    };
    const json = {
        tabs,
        tabs_array: Object.values(
            onlyVisible
                ? Object.fromEntries(
                      Object.entries(tabs).filter(([_, tab]) => tab.visible)
                  )
                : tabs
        ),
    };
    return json;
}

export const DEBOUNCE_DELAY = 700;

export const TABVIEW = 2;
